import { createUseStyles } from "react-jss";

export default createUseStyles({
    icon: {
        composes: "validation-error__icon",
        position: "relative",
        float: "left",
        fontSize: 30,
        color: ({ theme }) => theme.ErrorColor,
        marginRight: 14.5,
    },
    dynamicIcon: {
        left: -44,
    },
    validationError: {
        composes: "validation-error",
        position: "relative",
        fontWeight: 700,
        color: ({ theme }) => theme.ErrorColor,
        margin: [[14.5, 0]],
    },
    dynamicValidationError: {
        left: -41,
    },
});
